import React from 'react';
import { FaArrowUp, FaArrowDown, FaMinus } from 'react-icons/fa';

const BiasIndicator = ({ bias, size = 'medium', showLabel = true }) => {
  const normalizedBias = bias?.toLowerCase() || 'neutral';

  const getBiasConfig = () => {
    if (normalizedBias.includes('long') || normalizedBias.includes('bullish')) {
      return {
        icon: FaArrowUp,
        color: '#10b981',
        label: 'Bullish',
        bgColor: 'rgba(16, 185, 129, 0.15)',
        borderColor: 'rgba(16, 185, 129, 0.3)'
      };
    }
    if (normalizedBias.includes('short') || normalizedBias.includes('bearish')) {
      return {
        icon: FaArrowDown,
        color: '#ef4444',
        label: 'Bearish',
        bgColor: 'rgba(239, 68, 68, 0.15)',
        borderColor: 'rgba(239, 68, 68, 0.3)'
      };
    }
    return {
      icon: FaMinus,
      color: '#f59e0b',
      label: 'Neutral',
      bgColor: 'rgba(245, 158, 11, 0.15)',
      borderColor: 'rgba(245, 158, 11, 0.3)'
    };
  };

  const config = getBiasConfig();
  const Icon = config.icon;

  const sizeMap = {
    small: { icon: 14, padding: '4px 8px', fontSize: '12px' },
    medium: { icon: 18, padding: '8px 14px', fontSize: '14px' },
    large: { icon: 24, padding: '12px 20px', fontSize: '16px' }
  };

  const sizeConfig = sizeMap[size] || sizeMap.medium;

  return (
    <div
      className="bias-indicator"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: sizeConfig.padding,
        background: config.bgColor,
        border: `1px solid ${config.borderColor}`,
        borderRadius: '8px',
        color: config.color,
        fontWeight: '600',
        fontSize: sizeConfig.fontSize
      }}
    >
      <Icon size={sizeConfig.icon} />
      {showLabel && <span>{config.label}</span>}
    </div>
  );
};

export default BiasIndicator;
